import {
  AbstractControl,
  AbstractControlOptions,
  AsyncValidatorFn,
  FormControl,
  FormGroup,
  ValidatorFn,
} from '@angular/forms';
import { FormUtils } from '../../../utils/form.utils';

export type FileAwareFormMode = 'text' | 'file';

export class FileAwareForm extends FormGroup {
  constructor(
    controls: { [key: string]: AbstractControl<unknown, unknown> },
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
  ) {
    const allControls = {
      ...controls,
      mode: new FormControl<FileAwareFormMode>('text', { nonNullable: true }),
    };
    super(allControls, validatorOrOpts, asyncValidator);
  }

  public get currentMode(): FileAwareFormMode {
    return this.get('mode')?.value as FileAwareFormMode;
  }

  protected configureConditionalValidators(config: {
    fileAwareFields: string[];
    validators?: ValidatorFn | ValidatorFn[] | null;
  }) {
    FormUtils.configureConditionalValidators({
      ...config,
      mode: this.currentMode,
      form: this,
    });

    this.get('mode')?.valueChanges.subscribe((value) => {
      FormUtils.configureConditionalValidators({
        ...config,
        mode: value,
        form: this,
      });
    });
  }
}
